export default __webpack_public_path__ + "static/1503-4ff1f940f53a6cade37d7361f2ca50c3.gif";